module.exports = __webpack_public_path__ + "static/11-d787448701631c78518a4c0ee621a76c.jpeg";